import { gql } from '@apollo/client';

const ReferralListInfoShared = gql`
  fragment ReferralListInfoShared on Referral {
    id
    state
    hexCode
    consumedAt
    sentAt
    source
    partnerLocation {
      id
      name
    }
    userAttributes {
      id
      firstName
      lastName
    }
    patientAttributes {
      id
      firstName
      lastName
    }
    createdAt
  }
`;

export default ReferralListInfoShared;
